<HomeNavBar ref="homeNavBarRef" @active_profile="set_active_home_profile" />

<div class="px-2 h-100 marketplace-shell-wrap">
  <div class="container-fluid mt-2 marketplace-page-shell h-100">
       <div class="mb-3">
       <button
        class="btn rounded-circle p-2 d-flex align-items-center justify-content-center membership-view-back-btn"
        @click="go_back">
        <i class="bi bi-arrow-left fs-4"></i>
      </button>
    </div>

    <div
      v-if="loading"
      class="marketplace-loader-wrap d-flex align-items-center justify-content-center"
      role="status"
      aria-live="polite"
    >
      <div class="marketplace-loader-card">
        <div class="marketplace-loader-orbit">
          <span class="marketplace-loader-ring marketplace-loader-ring-primary"></span>
          <span class="marketplace-loader-ring marketplace-loader-ring-secondary"></span>
          <span class="marketplace-loader-core d-flex align-items-center justify-content-center">
            <i class="bi bi-tools fs-2 text-primary"></i>
          </span>
          <span class="marketplace-loader-dot marketplace-loader-dot-one"></span>
          <span class="marketplace-loader-dot marketplace-loader-dot-two"></span>
        </div>
        <p class="marketplace-loader-title mb-1">Loading services</p>
        <p class="marketplace-loader-copy mb-0">We are bringing your services and requests into view.</p>
      </div>
    </div>

    <div v-else>
      <div class="row align-items-center marketplace-header mb-3 g-3">
        <div class="col-12 col-lg-3">
          <div class="d-flex flex-column align-items-start gap-2">
            <h4 class="text-dark mb-1 fw-bold marketplace-toolbar-title">{{ page_title }}</h4>
            <p class="text-muted small mb-0">Manage your services and customer requests.</p>
            <button
              class="btn btn-link text-dark fw-semibold p-0 text-decoration-none d-inline-flex align-items-center gap-2 d-none"
              type="button"
              data-bs-toggle="offcanvas"
              data-bs-target="#myServicesActionsOffcanvas"
              aria-controls="myServicesActionsOffcanvas"
            >
              <i class="bi bi-list fs-4"></i>
              <span>Manage services</span>
            </button>
          </div>
        </div>

      </div>

      <div class="scrollable-container marketplace-shop-scroll flex-grow-1 pb-5 mb-5">
      <div v-if="active_tab === 'services'" class="row g-1 marketplace-products-grid">
        <div
          v-can-create.permission="service_create_permission"
          :class="catalogue_items.length === 0 ? 'col-12 catalogue-add-placeholder-empty' : 'col-6 col-sm-6 col-md-4 col-lg-4 col-xl-2 mb-1'"
        >
          <div
            class="catalogue-add-placeholder-card marketplace-product-card h-100 d-flex flex-column align-items-center justify-content-center text-center p-3 border-2 border-dashed bg-white pointer"
            data-bs-toggle="modal"
            data-bs-target="#addItemModal"
            @click="set_modal_type(add_item_modal_type)"
          >
            <div class="catalogue-add-placeholder-icon rounded-circle d-flex align-items-center justify-content-center mb-3">
              <i class="bi bi-plus-lg text-primary fs-4"></i>
            </div>
            <p class="fw-bold text-dark text-xs mb-1">Add Service</p>
            <p class="text-muted text-xxs mb-0">Click to create a service.</p>
          </div>
        </div>
        <div
          v-for="service in catalogue_items"
          :key="service.id"
          class="col-6 col-sm-6 col-md-4 col-lg-4 col-xl-2 mb-1"
        >
          <div
            class="marketplace-product-card h-100 d-flex flex-column position-relative"
            @click="view_service_details(service)"
          >
            <div class="position-relative marketplace-card-media">
              <div class="ratio ratio-4x3">
                <img
                  :src="service.images.length ? service.images[0].image_url : 'https://empirewebvideos.s3.us-east-1.amazonaws.com/worksteams/engagenet/images/image_placeholder.webp'"
                  :alt="service.name"
                  class="marketplace-card-image"
                />
              </div>

              <div class="position-absolute top-0 end-0 m-2">
                <div class="d-flex gap-2">
                  <span
                    class="badge"
                    :class="service.is_published ? 'task-chip task-chip-status' : 'task-due-chip d-inline-flex align-items-center fw-500 task-due-chip-overdue'"
                  >
                    {{ service.is_published ? 'Published' : 'Draft' }}
                  </span>
                </div>
              </div>
            </div>

            <div class="card-body p-3 d-flex flex-column text-start marketplace-card-body flex-grow-1">
              <div class="flex-grow-1">
                <p class="marketplace-card-name mb-1">{{ service.name }}</p>
                <p v-if="service?.service_details?.location" class="text-xs text-muted mb-0 mt-1">
                  <i class="bi bi-geo-alt-fill text-primary"></i>
                  <span><strong> Location:</strong> {{ service?.service_details?.location }}</span>
                </p>
              </div>

              <div class="d-flex justify-content-between align-items-end gap-2 mt-3 marketplace-card-footer">
                <div class="marketplace-card-price-wrap">
                  <span class="marketplace-card-price">R{{ format_price(display_price(service)) }}</span>
                </div>
              </div>

              <div class="mt-3">
                <div class="d-flex flex-wrap gap-1">
                  <button class="btn btn-primary rounded text-xxs py-1 px-2 flex-fill" @click.stop="toggle_publish(service)">
                    {{ service.is_published ? 'Unpublish' : 'Publish' }}
                  </button>
                  <button class="btn btn-secondary rounded text-xxs py-1 px-2 flex-fill" @click.stop="open_manage_modal(service)">
                    Manage
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-else class="row g-3 pb-extra-desktop">
        <div v-if="pending_requests.length === 0" class="col-12">
          <div class="text-center py-5">
            <i class="bi bi-telephone text-muted display-6"></i>
            <p class="text-muted text-xs mt-2 mb-0">No requests yet</p>
          </div>
        </div>

        <div v-for="request in pending_requests" :key="request.id" class="col-12 col-md-6 col-lg-4 col-xxl-3">
          <div class="card border-0 shadow-sm rounded p-3 h-100">
            <div class="d-flex align-items-center gap-2 mb-2">
              <div class="flex-fill overflow-hidden">
                <p class="mb-0 fw-bold text-xs text-dark text-truncate">{{ request?.requester?.user?.first_name + ' ' + request?.requester?.user?.last_name }}</p>
                <small class="text-muted text-xxs text-truncate d-block">{{ get_request_service_name(request) }}</small>
              </div>
              <span
                class="badge rounded-pill text-xxs"
                :class="{'bg-warning text-dark': request.status.name.toLowerCase() === 'pending','bg-success': request.status.name.toLowerCase() === 'approved',
                'bg-info': request.status.name.toLowerCase() === 'completed','bg-primary': request.status.name.toLowerCase() === 'cancelled',
                'bg-secondary': request.status.name.toLowerCase() === 'confirmed','bg-danger': request.status.name.toLowerCase() === 'declined',
                'bg-dark text-white': request.status.name.toLowerCase() === 'disputed'}"
              >
                {{ request?.status?.name ? request.status.name.charAt(0).toUpperCase() + request.status.name.slice(1).toLowerCase() : '' }}
              </span>
            </div>
            <div class="bg-light rounded p-2 mb-2">
              <small class="text-muted text-xxs fst-italic">{{ request?.message }}</small>
            </div>
            <div class="bg-light rounded p-2 mb-2">
              <small class="d-block text-xxs fw-semibold mb-1">Contacts</small>
              <small class="d-block text-muted text-xxs fst-italic">{{ request?.email }}</small>
              <small class="d-block text-muted text-xxs fst-italic">{{ request?.contact_number }}</small>
              <small class="d-block text-muted text-xxs fst-italic">{{ request?.location ? 'Location: ' + request?.location : 'Location: Not provided'}}</small>
              <small class="text-muted text-xxs d-block mb-2">{{ 'Preferred Date: ' + format_date(request?.request_date) }}</small>
            </div>
            <div v-if="request?.status?.name.toLowerCase() === 'pending'" class="d-flex gap-1">
              <button
                class="btn btn-sm btn-primary rounded flex-fill text-xxs"
                :disabled="request.is_loading"
                @click="update_request(request, 'approve', request.decline_reason)"
              >
                <span v-if="request.is_loading" class="spinner-border spinner-border-sm me-2"></span>
                Accept
              </button>
              <button
                class="btn btn-sm btn-secondary rounded flex-fill text-xxs"
                :disabled="request.is_loading"
                @click="request.show_decline = !request.show_decline"
              >
                Decline
              </button>
            </div>
            <div v-if="request.show_decline" class="mt-2">
              <textarea v-model="request.decline_reason" rows="2" class="form-control form-control-sm rounded mb-2 text-xxs" placeholder="Reason for declining..."></textarea>
              <div class="d-flex gap-1">
                <button
                  class="btn btn-sm btn-danger rounded flex-fill text-xxs"
                  :disabled="request.is_loading"
                  @click="update_request(request, 'decline', request.decline_reason); request.show_decline = false"
                >
                  <span v-if="request.is_loading" class="spinner-border spinner-border-sm me-2"></span>
                  Submit
                </button>
                <button class="btn btn-sm btn-light rounded flex-fill text-xxs" @click="request.show_decline = false; request.decline_reason = ''">
                  Cancel
                </button>
              </div>
            </div>
            <div v-if="['approved', 'disputed'].includes(request?.status?.name.toLowerCase())" class="d-flex gap-1">
              <button
                class="btn btn-sm btn-primary rounded flex-fill text-xxs"
                :disabled="request.is_loading"
                @click="update_request(request, 'complete', request.decline_reason)"
              >
                <span v-if="request.is_loading" class="spinner-border spinner-border-sm me-2"></span>
                Complete
              </button>
            </div>
          </div>
        </div>
      </div>
      </div>
    </div>
  </div>
</div>

<div class="offcanvas offcanvas-end home-nav-offcanvas bg-light border-start" tabindex="-1" id="myServicesActionsOffcanvas" aria-labelledby="myServicesActionsOffcanvasLabel">
  <div class="offcanvas-header home-nav-offcanvas-header bg-white border-bottom px-4 py-3">
    <div>
      <h6 class="home-nav-offcanvas-title text-dark fw-bold mb-0 mt-1" id="myServicesActionsOffcanvasLabel">Manage services</h6>
    </div>
    <button type="button" class="btn-close text-reset home-nav-offcanvas-close rounded-circle bg-light opacity-100" data-bs-dismiss="offcanvas" aria-label="Close"></button>
  </div>
  <div class="offcanvas-body home-nav-offcanvas-body d-flex flex-column gap-3 p-3">
    <section class="home-nav-menu-section d-flex flex-column gap-1">
      <div class="home-nav-menu-heading d-flex align-items-center justify-content-between px-1 text-muted text-xxs fw-bold text-uppercase lh-1">
        <span>Service Tools</span>
      </div>
   
      <button
        v-can-create.permission="'services'"
        class="home-nav-menu-row primary w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        data-bs-toggle="modal"
        data-bs-target="#addItemModal"
        data-bs-dismiss="offcanvas"
        @click="set_modal_type(add_item_modal_type)"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bi bi-plus-lg"></i></span>
        <span class="min-w-0 flex-grow-1 d-flex flex-column lh-sm">
          <span class="text-dark fw-500 text-xxs">Add {{ add_item_label }}</span>
          <small class="text-muted text-xxs fw-500">Create a new service for your catalogue.</small>
        </span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>
      <button
        class="home-nav-menu-row primary w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        data-bs-dismiss="offcanvas"
        @click="active_tab = 'requests'"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary">
        <i class="bi bi-telephone"></i></span>
        <span class="min-w-0 flex-grow-1 d-flex flex-column lh-sm">
          <span class="text-dark fw-500 text-xxs">View requests</span>
          <small class="text-muted text-xxs fw-500">Review service requests from customers.</small>
        </span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>
      <button
        v-if="can_create_business_profile_action"
        class="home-nav-menu-row primary w-100 border rounded bg-white text-dark d-flex align-items-center gap-3 text-start"
        type="button"
        data-bs-dismiss="offcanvas"
        @click="open_business_profile_from_actions"
      >
        <span class="home-nav-menu-icon flex-shrink-0 rounded d-inline-flex align-items-center justify-content-center text-primary"><i class="bi bi-briefcase"></i></span>
        <span class="min-w-0 flex-grow-1 d-flex flex-column lh-sm">
          <span class="text-dark fw-500 text-xxs">Create Business Profile</span>
          <small class="text-muted text-xxs fw-500">Set up a business profile for your services.</small>
        </span>
        <i class="bi bi-chevron-right home-nav-menu-arrow ms-auto text-primary"></i>
      </button>
    </section>
  </div>
</div>

<button
  v-can-create.permission="'services'"
  class="marketplace-owner-fab"
  type="button"
  aria-label="Open manage services"
  title="Manage services"
  data-bs-toggle="offcanvas"
  data-bs-target="#myServicesActionsOffcanvas"
  aria-controls="myServicesActionsOffcanvas"
>
  <i class="bi bi-tools"></i>
  <span class="marketplace-owner-fab-plus">
    <i class="bi bi-plus-lg"></i>
  </span>
</button>

<CatalogueView :vm="view_model"></CatalogueView>
